import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Header from "./Header";

const CASES = [
  { id: 1, label: "Grocery Order" },
  { id: 2, label: "Patient Referral" },
  { id: 3, label: "Automotive Dealer Order" },
  { id: 4, label: "Pharma Order" },
  { id: 5, label: "Middle-East Help Center" },
  { id: 6, label: "Transcription" },
  { id: 7, label: "Report Generation" },
  { id: 8, label: "Field Extraction" },
];

export default function Home() {
  const navigate = useNavigate();
  const [selectedCase, setSelectedCase] = useState("");

  const handleExploreSolution = () => {
    if (!selectedCase) return;
    navigate("/vocalis", { state: { caseName: selectedCase } });
  };

  return (
    <div data-theme="dark">
      <div className="fixed inset-0 w-full h-full pointer-events-none z-0 transition-colors duration-500">
        <div
          className="absolute top-[-10%] left-[-10%] w-96 h-96 rounded-full blur-[100px]"
          style={{ background: "var(--bg-grad-1)" }}
        ></div>
        <div
          className="absolute bottom-[-10%] right-[-10%] w-96 h-96 rounded-full blur-[100px]"
          style={{ background: "var(--bg-grad-2)" }}
        ></div>
      </div>

      <div
        className="relative z-10 w-full max-w-md mx-auto flex flex-col shadow-2xl transition-all duration-500 overflow-hidden"
        style={{
          height: "100dvh",
          background: "rgba(2, 6, 23, 0.8)",
          borderLeft: "1px solid var(--glass-border)",
          borderRight: "1px solid var(--glass-border)",
        }}
      >
        <div
          id="screen-home"
          className="absolute inset-0 flex flex-col bg-transparent z-30"
        >
          <Header BackTo={""} />

          <div className="flex-1 flex flex-col justify-center items-center gap-6 p-6">
            <div className="w-full flex flex-col gap-3">
              <label className="text-xs uppercase tracking-widest text-muted font-semibold">
                Select a Case
              </label>
              <div className="relative">
                <select
                  value={selectedCase}
                  onChange={(e) => setSelectedCase(e.target.value)}
                  className="w-full appearance-none rounded-2xl px-5 py-4 text-base font-medium cursor-pointer transition-all focus:outline-none focus:ring-2 focus:ring-cyan-500/50"
                  style={{
                    background: "var(--input-bg, rgba(255,255,255,0.05))",
                    border: "1px solid var(--glass-border)",
                    color: selectedCase ? "var(--text-main, #fff)" : "var(--text-muted, #6b7280)",
                  }}
                >
                  <option value="" disabled style={{ background: "#0f172a", color: "#6b7280" }}>
                    — Choose a case —
                  </option>
                  {CASES.map((c) => (
                    <option
                      key={c.id}
                      value={c.label}
                      style={{ background: "#0f172a", color: "#fff" }}
                    >
                      Case {c.id}: {c.label}
                    </option>
                  ))}
                </select>
                <div className="pointer-events-none absolute inset-y-0 right-4 flex items-center">
                  <svg
                    className="w-5 h-5 text-cyan-400"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M19 9l-7 7-7-7"
                    />
                  </svg>
                </div>
              </div>
            </div>

            <button
              onClick={handleExploreSolution}
              disabled={!selectedCase}
              className="relative w-full h-16 rounded-2xl bg-gradient-to-br from-cyan-600 to-blue-700 flex items-center justify-center gap-3 shadow-lg active:scale-95 transition-transform cursor-pointer group overflow-hidden disabled:opacity-40 disabled:cursor-not-allowed disabled:active:scale-100"
            >
              <div className="absolute inset-0 bg-white/0 group-hover:bg-white/10 transition-colors"></div>
              <svg
                className="w-6 h-6 text-white"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M13 7l5 5m0 0l-5 5m5-5H6"
                />
              </svg>
              <span className="text-lg font-bold text-white">Explore Solution</span>
            </button>

            <button
              onClick={() => navigate("/records")}
              className="relative w-full h-12 rounded-2xl flex items-center justify-center gap-2 transition-all cursor-pointer active:scale-95"
              style={{
                background: "rgba(255,255,255,0.04)",
                border: "1px solid rgba(255,255,255,0.1)",
              }}
            >
              <svg
                className="w-5 h-5"
                style={{ color: "var(--text-accent, #22d3ee)" }}
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                />
              </svg>
              <span className="text-sm font-semibold" style={{ color: "var(--text-accent, #22d3ee)" }}>
                View Records
              </span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
